
import Price from '~/components/Price';
export default {
  components: { Price },
  inheritAttrs: false,
  props: {
    lowPrice: { type: Number },
    highPrice: { type: Number },
    priceCurrency: { type: String },
    offerCount: { type: Number, required: true },
  },
};
